import { useState } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { EmptyConversation } from "@/types";
import { Link } from "react-router-dom";
import PlaceholderLoading from "react-placeholder-loading";

type MatchesProps = {
  conversations: EmptyConversation[] | null;
};

const MatchPlaceholder = () => {
  return (
    <div className="flex flex-col items-center space-y-1 match-placeholder">
      <PlaceholderLoading shape="circle" width={56} height={56} />
      <PlaceholderLoading shape="rect" width={56} height={10} />
    </div>
  );
};

export function Matches({ conversations }: MatchesProps) {
  return (
    <div>
      <h2 className="text-xl font-bold mb-4 text-primary">Your Matches</h2>
      <ScrollArea className="w-full whitespace-nowrap rounded-md">
        <div className="flex w-max space-x-4">
          {conversations === null &&
            [1, 2, 3, 4, 5].map((n) => <MatchPlaceholder />)}
          {conversations?.length === 0 && <div>No pending matches</div>}
          {conversations?.map((match) => (
            <div
              key={match.id}
              className="flex flex-col items-center space-y-1"
            >
              <Link to={`/app/chat/${match.id}`}>
                <Avatar className="w-14 h-14">
                  <AvatarImage src={match.image} alt={match.name} />
                  <AvatarFallback>{match.name[0]}</AvatarFallback>
                </Avatar>
                <span className="text-xs font-medium text-gray-300">
                  {match.name}
                </span>
              </Link>
            </div>
          ))}
        </div>
        <ScrollBar orientation="horizontal" />
      </ScrollArea>
    </div>
  );
}
